/* Footer-only progressive enhancement. Links remain available without JavaScript. */
(() => {
  'use strict';
  if (window.__mmR32MegaFooter) return;
  window.__mmR32MegaFooter = true;
  const bound = new WeakMap();
  const initialize = (scope = document) => {
    const roots = scope.matches?.('[data-mm-mega-footer]')
      ? [scope] : [...scope.querySelectorAll('[data-mm-mega-footer]')];
    roots.forEach(root => {
      if (bound.has(root)) return;
      const groups = [...root.querySelectorAll('[data-mm-mega-group]')];
      const mq = window.matchMedia('(max-width:700px)');
      const sync = () => {
        if (!root.isConnected) return;
        const active = document.activeElement;
        groups.forEach(group => {
          const summary = group.querySelector('summary');
          if (mq.matches && active && group.contains(active) && active !== summary) summary?.focus();
          group.open = !mq.matches;
        });
      };
      // Desktop groups stay open; mobile uses the native keyboard/touch disclosure.
      const keepDesktopOpen = event => {
        if (mq.matches) return;
        const summary = event.target.closest('summary');
        if (summary?.parentElement?.matches('[data-mm-mega-group]')) event.preventDefault();
      };
      const changed = () => sync();
      root.addEventListener('click', keepDesktopOpen);
      mq.addEventListener('change', changed);
      bound.set(root, {mq, changed, keepDesktopOpen});
      root.dataset.mmMegaReady = 'true';
      sync();
    });
  };
  const remove = scope => {
    const roots = scope.matches?.('[data-mm-mega-footer]')
      ? [scope] : [...scope.querySelectorAll('[data-mm-mega-footer]')];
    roots.forEach(root => {
      const binding = bound.get(root);
      if (!binding) return;
      binding.mq.removeEventListener('change', binding.changed);
      root.removeEventListener('click', binding.keepDesktopOpen);
      bound.delete(root);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => remove(event.target));
})();
